import getEnv from "@/config/env";

export const FILTERCONDITION = {
  match_phrase_prefix: "match_phrase_prefix",
  exact: "term",
  exists: "exists",
  must_not: "must_not",
};

export const CAPTCHA_SITE_KEY = getEnv("VUE_APP_CAPTCHA_SITE_KEY");

export const INTERACTION_POINT = {
  LOGIN: "call_login_page_session_login",
  REFRESHTOKEN: "call_list_page_session_refresh_token",
  SELECT_OPERATOR: "call_list_page_select_operator",
  CALL_LIST_DETAILS: "call_list_page_call_details",
  CALL_LIST_DOWNLOAD_AUDIO_FILE: "call_list_page_call_audio_download",
  CALL_DETAIL_DOWNLOAD_AUDIO_FILE: "call_detail_page_call_audio_download",
  CALL_DETAIL_DOWNLOAD_AUDIO_TEXT: "call_detail_page_call_text_download",
  CALL_DETAIL_DOWNLOAD_AUDIO_MASKED_TEXT: "call_detail_page_call_masked_text_download",
  CALL_DETAIL_DOWNLOAD_AUDIO_SUMMARY: "call_detail_page_call_summary_download",
  CALL_DETAIL_DOWNLOAD_AUDIO_SUMMARY_MASKED: "call_detail_page_call_summary_masked_download",
  REGENERATE_AUDIO_TEXT_PROCESSED: "call_detail_page_regenerate_audio_text_processed",
  CALL_DETAIL_SIP_PAYLOAD_VIEW: "call_detail_page_view_sip_payload",
  CREATE_SUMMARY: "call_detail_page_create_summary",
  UPDATE_CALL_TITLE: "call_detail_page_update_call_title",
  UPDATE_CALL_NOTES: "call_detail_page_update_call_notes",
  DELETE_CALL: "call_detail_page_delete_call",
  DELETE_BULK_CALLS: "call_list_page_bulk_delete_calls",
  MASKING_TEXT_AUDIO: "call_detail_page_mask_audio",
  MASKING_TEXT_SUMMARY: "call_detail_page_mask_summary",
  MODIFY_SUMMARY: "call_detail_page_modify_summary",
  APPLY_FILTER: "call_list_page_call_filter",
  CALL_DETAIL_CALL_CLOSE: "call_detail_page_close_call_details",
  LOGOUT: "call_list_page_session_logout",
};
